<template>
  <div class="main_center" ref="middle">
    <div class="search-content">
      <el-form ref="form" class="conditionForm" :model="form" label-width="110px">
          <el-row>
              <el-col :span="6">
                  <el-form-item label="场地楼层：">
                      <el-cascader
                              style="width:100%"
                              placeholder="请选择场地楼层"
                              :options="options"
                              clearable
                              v-model="selectedOptions"
                              @change="cascaderChange"
                      />
                  </el-form-item>
              </el-col>
              <el-col :span="7" :offset="1">
                  <el-form-item label="采集时间段：">
                      <el-date-picker
                              style="width: 100%"
                              v-model="form.datetimerange"
                              @change="datetimerangePicker"
                              :clearable="false"
                              :picker-options="pickerOptions"
                              type="datetimerange"
                              format="yyyy-MM-dd HH:mm:ss"
                              value-format="yyyy-MM-dd HH:mm:ss"
                              range-separator="至"
                              start-placeholder="开始日期"
                              end-placeholder="结束日期">
                      </el-date-picker>
                  </el-form-item>
              </el-col>
              <el-col :span="5" :offset="1">
                  <el-form-item label="姓名：">
                      <el-input v-model="form.name" clearable placeholder="请输入姓名" @keyup.enter.native="searchBtn"></el-input>
                  </el-form-item>
              </el-col>
              <el-col :span="6" v-if="moreSearchItem">
                  <el-form-item label="角色：">
                      <el-select v-model="form.role" clearable placeholder="请选择角色"  @change="searchBtn">
                          <el-option label="全部" value="99"></el-option>
                          <el-option v-for="(item,index) in  rolesList"
                                     :key="index"
                                     :label="item.name"
                                     :value="item.value"></el-option>
                      </el-select>
                  </el-form-item>
              </el-col>
              <el-col :span="7" :offset="1" v-if="moreSearchItem">
                  <el-form-item label="进出标志：">
                      <el-select v-model="form.sign" clearable placeholder="请选择进出标志"  @change="searchBtn">
                        <el-option
                          label="全部"
                          value="0"
                        />
                        <el-option
                          label="进"
                          value="1"
                        />
                        <el-option
                          label="出"
                          value="2"
                        />
                        <el-option
                          label="非法"
                          value="-1"
                        />
                      </el-select>
                  </el-form-item>
              </el-col>
<!--              <el-col :span="7" v-if="moreSearchItem">-->
<!--                  <el-form-item label="采集门禁：">-->
<!--                      <el-select v-model="form.control" clearable placeholder="请选择采集门禁"  @change="searchBtn">-->
<!--                        <el-option-->
<!--                          label="全部"-->
<!--                          value="0"-->
<!--                        />-->
<!--                      </el-select>-->
<!--                  </el-form-item>-->
<!--              </el-col>-->
<!--              <el-col :span="7" v-if="moreSearchItem">-->
<!--                  <el-form-item label="采集时间：">-->
<!--                    <el-date-picker-->
<!--                            style="width: 100%"-->
<!--                            v-model="form.date"-->
<!--                            @change="searchBtn"-->
<!--                            type="daterange"-->
<!--                            format="yyyy-MM-dd"-->
<!--                            value-format="yyyy-MM-dd"-->
<!--                            range-separator="至"-->
<!--                            start-placeholder="开始日期"-->
<!--                            end-placeholder="结束日期">-->
<!--                    </el-date-picker>-->
<!--                  </el-form-item>-->
<!--              </el-col>-->
              <!-- <el-col :span="7" :offset="1" v-if="moreSearchItem">
                  <el-form-item label="监控具体位置：" props="businessCode">
                      <el-input v-model="form.site" clearable placeholder="请输入内容搜索" @keyup.enter.native="searchBtn"></el-input>
                  </el-form-item>
              </el-col> -->
            <div class="searchBtn">
              <el-button size="small" type="primary" @click="searchBtn">搜索</el-button>
              <el-button @click="moreSearchItem = true" icon="el-icon-arrow-down" size="mini" type="text" v-if="!moreSearchItem">更多搜索</el-button>
              <el-button size="mini" type="text" v-if="moreSearchItem" @click="moreSearchItem = false" icon="el-icon-arrow-up">收起</el-button>
                <el-divider direction="vertical"></el-divider>
                <el-button @click="refresh" icon="el-icon-refresh" type="text"></el-button>
            </div>
          </el-row>
      </el-form>
    </div>
    <div class="track-content">
      <div class="track-top">
        <div class="top-title">
           门禁出入视频
        </div>
<!--        <div>-->
<!--          <el-button type="primary" size="small" icon="el-icon-video-play">全部播放</el-button>-->
<!--          <el-button icon="el-icon-video-pause" size="small" >全部暂停</el-button>-->
<!--          <el-dropdown style="margin-left:10px" @command="composeValue" size="small" >-->
<!--            <el-button el-button>{{speedValue}}X<i class="el-icon-arrow-down el-icon&#45;&#45;right"></i></el-button>-->
<!--            <el-dropdown-menu slot="dropdown">-->
<!--              <el-dropdown-item command="1">1 X</el-dropdown-item>-->
<!--              <el-dropdown-item command="2">2 X</el-dropdown-item>-->
<!--              <el-dropdown-item command="3">3 X</el-dropdown-item>-->
<!--              <el-dropdown-item command="0.5">0.5 X</el-dropdown-item>-->
<!--              <el-dropdown-item command="0.75">0.75 X</el-dropdown-item>-->
<!--            </el-dropdown-menu>-->
<!--          </el-dropdown>-->
<!--        </div>-->
      </div>
      <div class="track-middle">
        <el-row :gutter="6" v-if="videoList.length > 0">
            <el-carousel :autoplay="false"
                         v-if="videoList.length > 0"
                         style="height:900px;"
                         indicator-position="none">
                <el-carousel-item v-for="i in Math.ceil(videoList.length / 6)" :key="i"  style="height:900px">
                    <el-col :span="total<=1?24:total<=4?12:8"
                            style="margin-bottom: 6px"
                            v-for="(item,index) in videoList.slice((i-1)*6,videoList.length>=(i)*6?(i*6):(videoList.length))"
                            :key="item.id">
                        <guardVideo :videoInfo="item" :i="index" :total="total" :record="true" :height="total<=2?'900px':'450px'"></guardVideo>
                    </el-col>
                </el-carousel-item>
            </el-carousel>
        </el-row>
          <el-row v-else style="position: relative;height:900px">
              <iframe
                      v-if="isIE"
                      style="position:absolute;z-index:-1;width:100%;height:100%;top:0;left:0;right:0;bottom:0"
                      allowtransparency="true"
                      frameborder="0"
              />
              <stream-player
                      ref="streamPlayerRefs1"
                      :width="'900px'"
                      :height="vlcHeight"
                      :video-url.sync="videoUrl"
                      video-code="flv"
              />
              <!--                  <emptyInfo v-if="videoList.length == 0" :emptyMsg="'暂无视频数据'" ></emptyInfo>-->
          </el-row>
      </div>
    </div>
    <record-frame-list />
  </div>
</template>

<script>
import moment from 'moment'
import 'moment/locale/zh-cn'
import { isIEBrowser } from '@/utils'
import guardVideo from './components/guardVideo'
import RecordFrameList from './components/RecordFrameList'
import emptyInfo from '@/components/empty-info';
import StreamPlayer from '@/components/videoPlayer/streamPlayer'
export default {
  components: {
      guardVideo,
      emptyInfo,
      StreamPlayer,
      RecordFrameList,
  },
  data() {
    return {
      options: [],
        selectedOptions:[],
        rolesList:[],
        videoList:[],
        location:'',
        tradeOrgId:'',
        pickerOptions: {
            disabledDate(time) {
                return time.getTime() > new Date().setHours(new Date().getHours() -1);
            }
        },
      personRoleList:[],
      inoutFlagList:[],
      moreSearchItem:false,
        deleteBtnShow:false,
      form:{
        name:'',
        role:'',
        date:'',
        sign:'',
        control:'',
        datetimerange:'',
        type:''
      },
      speedValue:'1',
      timer:null,
      vlcWidth: '',
      vlcHeight: '',
      isIE: false,
      // 视频流
      videoUrl: '',
      test:[1,2,3,4],
      currentOffset:0,
      width:"",
      fatherWith:0,
      box:'',
        total:0,
        pageIndex:1,
        pageSize:6,
      // 中间整体全屏
      fullscreen: false,
      // 单个视频全屏
      videoFull:false
    };
  },
  filters: {

  },
  created() {
    this.isIE = isIEBrowser();
    this.getDic('jz_dgwitness_person_role')
    this.getSelectData();
      let now = new Date();
    var anHourAgo = now.setHours(now.getHours() -1)//小时
    var aDayAgo = now.setDate(now.getDate() -1)//一天
    this.form.datetimerange = [this.formatDate(new Date(),'yyyy-MM-dd' + ' 00:00:00'),this.formatDate(anHourAgo,'yyyy-MM-dd HH:mm:ss')];
  },
  activated() {

  },
  mounted() {

  },
  deactivated() {

  },
  beforeRouteLeave(from, to, next) {
    this.$destroy()
    next()
  },
  methods: {
      getDic(type) { // 获取字典

          this.$httpReq.get('/sys/dictData/getList?type=' + type).then(res => {
              if (res.data.code === '1') {
                  switch (type) {
                      case 'jz_dgwitness_person_role':this. rolesList = res.data.data;break;
                  }
              }
          })
      },
      cascaderChange(val){
          this.tradeOrgId = val[0];
          this.location = val[1];
          this.getVideoData()
      },
      getSelectData(){
          this.$httpReq.get('/sysGuardConfig/getDropDownList').then((res)=>{
              if(res.data.code == '1'){
                  let resData = res.data.data;
                  this.options = resData;
                  if(resData[0] && resData[0].children && resData[0].children[0]){
                      this.tradeOrgId = resData[0].children[0].tradeOrgId;
                      this.location = resData[0].children[0].value;
                      this.selectedOptions = [resData[0].children[0].tradeOrgId,resData[0].children[0].value];
                      this.getVideoData();
                  }

              }
          })
      },
      getVideoData(){
          let now =  new Date()
          var anHourAgo = now.setHours(now.getHours() -1);
          var todayBegin = new Date(this.formatDate(new Date(),'yyyy-MM-dd' + ' 00:00:00'))
          let startTime = this.form.datetimerange[0]?new Date(this.form.datetimerange[0]).getTime():todayBegin.getTime();
          let endTime = this.form.datetimerange[1]?new Date(this.form.datetimerange[1]).getTime():anHourAgo.getTime();
          this.videoList = [];
          this.$httpReq.get(`/sysGuardConfig/getGuardConfigs?tradeOrgId=${this.tradeOrgId}&location=${this.location}&startTime=${startTime/1000}&endTime=${endTime/1000}`).then((res)=>{
              if(res.data.code == '1'){
                  this.videoList = res.data.data || [];
                  // this.videoList = [
                  //     {streamUrl:'http://flv.bdplay.nodemedia.cn/live/bbb.flv'},
                  // ]
                  this.total = this.videoList.length;
              }
          })
      },

      datetimerangePicker(datetimerange){
          if(datetimerange.length == 0){
              this.message.error("日期不能为空。");
              let now = new Date();
              var anHourAgo = now.setHours(new Date().getHours() -1)//1小时前
              var aDayAgo = now.setHours(new Date().getDate() -1)//一天前
              this.form.datetimerange = [this.formatDate(new Date(),'yyyy-MM-dd' + ' 00:00:00'),this.formatDate(anHourAgo,'yyyy-MM-dd HH:mm:ss')];
              return
          }
          let now  = new Date();
          let startTime = datetimerange[0];
          let endTime = datetimerange[1];
          let limitStartTime = now.setTime(now.getTime() - 75 * 60 * 1000);
          let limitEntTime = new Date().setHours(new Date().getHours() -1);

          if(new Date(startTime) > new Date(limitStartTime) || new Date(endTime) > new Date(limitEntTime)){
              this.message.error("选择时间段均不得晚于当前时间一小时前，且时间差不得少于半小时。");
              now.setTime(now.getTime() - 15 * 60 * 1000);
              let limitStartTime = new Date().setHours(new Date().getHours() -1)
              if(new Date(startTime) > new Date(limitStartTime)){
                  startTime = this.formatDate(limitStartTime,'yyyy-MM-dd HH:mm:ss');
              }
              if( new Date(endTime) > new Date(limitEntTime)){
                  endTime = this.formatDate(limitEntTime,'yyyy-MM-dd HH:mm:ss');
              }
              this.form.datetimerange = [startTime,endTime]
              return
          }
          this.form.datetimerange = datetimerange

      },
    // 搜索
    searchBtn(){
        this.getVideoData();

    },
    // 刷新
    refresh(){
          this.form.name = '';
          this.form.role = '';
          this.form.sign = '';
          this.getVideoData();
    },


    composeValue(item){
      console.log(item)
      this.speedValue=item
    },
    right() {
      if(this.currentOffset <= (-(this.fatherWith-4) / 10)*(20-10)) return
      this.currentOffset-=((this.fatherWith-4) / 10)
    },
    left() {
      if(this.currentOffset >= -2) return
      this.currentOffset+=((this.fatherWith-4) / 10)
    },
    // 下一页
    nextPage(){},
    // 全屏
    screen(){
      let element = this.$refs.middle;
      if (this.fullscreen) {
        if (document.exitFullscreen) {
        document.exitFullscreen();
        } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
        } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
        }
      } else {
        if (element.requestFullscreen) {
        element.requestFullscreen();
        } else if (element.webkitRequestFullScreen) {
        element.webkitRequestFullScreen();
        } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen();
        } else if (element.msRequestFullscreen) {
        // IE11
        element.msRequestFullscreen();
        }
      }
      this.fullscreen = !this.fullscreen;
    },
    // 视频全屏
    screenVideo(i){
      let element = document.getElementById("full" + i);
      if (this.videoFull) {
        if (document.exitFullscreen) {
        document.exitFullscreen();
        } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
        } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
        }
      } else {
        if (element.requestFullscreen) {
        element.requestFullscreen();
        } else if (element.webkitRequestFullScreen) {
        element.webkitRequestFullScreen();
        } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen();
        } else if (element.msRequestFullscreen) {
        // IE11
        element.msRequestFullscreen();
        }
      }
      this.videoFull = !this.videoFull;
    }
  },
};
</script>
<style lang="scss" scoped>
.track-content{
  width:100%;
  background: #001F39;
  border-radius: 2px;
  padding:0 16px 16px;
  color: #fff;
  .track-top{
    height:56px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .top-title{
      font-size: 16px;
    }
    .el-button{
      background: rgba(24, 144, 255, 0.25);
      border-radius: 2px;
      border: 1px solid rgba(24, 144, 255, 0.45);
      padding: 8px 13px;
      color: #FFFFFF;
    }
    .el-button--primary{
      background: #1890FF;
    }
    /deep/ .el-icon-video-play,/deep/ .el-icon-video-pause{
      vertical-align: middle;
    }
  }
  .track-middle{
    position: relative;
    .track-video{
      width:100%;
      // padding: 24px;
      background: #001F39;
      border-radius: 2px;
      display: inline-block;
      box-sizing: border-box;
      position: relative;
      .video-title-fixed{
        position:absolute;
        width:100%;
        height: 48px;
        z-index: 99;
        background: rgba(0, 13, 23, 0.6);
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 22px;
        .video-left{
          display: flex;
          justify-content: space-between;
          align-items: center;
          .left-title{
            font-size: 16px;
          }
          .sub{
            color: rgba(255, 255, 255, 0.25);
            padding:0 24px;
          }
          .left-adr{
            font-size: 12px;
          }
        }
        .video-right{
            transform: rotate(45deg);
          .el-button--text {
            opacity: 0.65;
            color:#fff;
            font-size: 24px;
            vertical-align: middle;
          }
        }
      }
      .video-img-fixed{
        height: 40px;
        width: calc(100% - 24px);
        position: absolute;
        bottom: 0px;
        margin:0 12px 9px 12px;
        overflow: hidden;
        .swiper-box{
          height:40px;
          vertical-align: middle;
          width:calc(100% - 32px);
          margin-left:16px;
          margin-right:16px;
          display: flex;
        }
        .icon-left{
          position: relative;
          width: 12px;
          height: 40px;
          background: rgba(255, 255, 255, 0.25);
          display: inline-block;
          top:-40px;
          left:0;
          cursor: pointer;
          .left{
            position: absolute;
            top:13px;
            left:0
          }
        }
        .icon-right{
          position: absolute;
          width: 12px;
          height: 40px;
          background: rgba(255, 255, 255, 0.25);
          display: inline-block;
          top:0;
          right:0;
          cursor: pointer;
          .right{
            position: absolute;
            right: 0;
            top: 13px;
          }
        }
      }
      .video-img-noicon{
        margin:0 12px 9px 8px;
        width:calc(100% - 20px);
        .swiper-box-noicon{
          width:100%;
          margin:0;
        }
      }
    }
    .icon-fixed{
      position: absolute;
      right: 0;
      font-size: 48px;
      z-index: 999;
      top: 47%;
      background: rgba(255, 255, 255, 0.25);
    }
  }
}
/deep/ .el-range-editor--medium.el-input__inner{
  height: 35px!important;
}


</style>
